import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={25.701}
    height={25.388}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 139282 137584"
    {...props}
  >
    <path
      d="M4389 71340 36741 3398h65798l32352 67942H4389zm89031 49256c0 4914-1471 9594-4262 13588l-39034 2c-2791-3994-4264-8676-4264-13590 0-13111 10667-23778 23780-23778s23780 10667 23780 23778zM42464 90022c0 1874-1524 3398-3398 3398-1872 0-3396-1524-3396-3398 0-1870 1524-3396 3396-3396 1874 0 3398 1526 3398 3396zM105144 971c-283-594-879-971-1534-971H35670c-655 0-1251 377-1534 971L166 72309c-107 221-162 459-166 698v54c4 307 92 614 262 886 312 492 854 789 1436 789h35670v8709c-2927 756-5096 3419-5096 6577 0 3748 3048 6796 6794 6796s6794-3048 6794-6796c0-3158-2169-5821-5096-6577v-8709h27178v18739c-14198 877-25478 12708-25478 27121 0 5938 1880 11579 5436 16310 322 428 823 678 1358 678l40766-2c535 0 1038-250 1358-678 3556-4731 5434-10370 5434-16308 0-14413-11280-26244-25478-27121V74736h66244c582 0 1124-297 1436-789 311-495 348-1114 96-1638L105144 971z"
      style={{
        fill: "#1c1c1d",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
